var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "strike-price-grid ag-grid--custom ag-theme-balham-dark",
      style: { maxWidth: _vm.gridWidth + "px" },
      attrs: { "data-testid": "strike-price-grid" },
      on: {
        "!keydown": function($event) {
          return _vm.onKeyDown.apply(null, arguments)
        }
      }
    },
    [
      _c("AgGridVue", {
        staticClass: "strike-price-grid__ag",
        attrs: {
          "column-defs": _vm.columnDefs,
          "default-col-def": _vm.defaultColDef,
          context: _vm.gridContext,
          "get-row-node-id": _vm.getRowNodeId,
          "dom-layout": "autoHeight",
          "enable-range-selection": true,
          "enable-fill-handle": _vm.editable,
          "suppress-context-menu": true,
          "suppress-movable-columns": true,
          "enter-moves-down-after-edit": true,
          "stop-editing-when-grid-loses-focus": true,
          "header-height": 28,
          "row-height": 28,
          "process-cell-from-clipboard": _vm.processCellFromClipboard,
          "process-cell-for-clipboard": _vm.processCellForClipboard
        },
        on: {
          "grid-ready": _vm.onGridReady,
          "cell-clicked": _vm.onCellClicked,
          "cell-editing-stopped": _vm.onCellEditingStopped,
          "cell-value-changed": _vm.scheduleSync,
          "paste-end": _vm.scheduleSync,
          "fill-end": _vm.scheduleSync
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }